import React from "react";
import { Input, Label } from "./FormStyles";
import CheckRender from "../Common/CheckRender";
import useEmpresa from "../../hooks/useEmpresa";
import Space from "../Common/Space";

const CustomIconInput = ({
  type,
  label,
  placeholder,
  value,
  onChange,
  fontSize,
  borderRadius,
  responsiveFontSize,
  responsivePadding,
  width,
  height,
  disabled,
  icons,
  position,
  maxLength
}) => {
  const empresa = useEmpresa();

  const handleChange = (event) => {
    const inputValue = event.target.value;
    onChange(inputValue);
  };

  return (
    <>
      <CheckRender allowed={label}>
        <Label font={empresa?.LETRA_PRINCIPAL}>{label}</Label>
      </CheckRender>

      <Space size={1}>
        <Input
          type={type}
          placeholder={placeholder}
          fontSize={fontSize}
          borderRadius={borderRadius}
          responsiveFontSize={responsiveFontSize}
          responsivePadding={responsivePadding}
          value={value || ""}
          onChange={handleChange}
          font={empresa?.LETRA_PRINCIPAL}
          width={width}
          height={height}
          disabled={disabled}
          maxLength={maxLength}
        />
        <CheckRender allowed={icons}>{icons}</CheckRender>
      </Space>
      </>
  );
};

export default CustomIconInput;